import React from "react";
import { currencyFormatter } from "../helper";

export default function UnionSet({
  hospital,
  spent,
  revenue,
  loading,
}: {
  hospital: string;
  spent: string;
  revenue: string;
  loading: boolean;
}) {
  return (
    <>
      <div className="relative flex flex-col">
        <div className="relative w-80">
          <div className="rounded-full w-44 h-44 border-2 border-white border-dashed absolute flex items-center justify-center bg-bloodRed opacity-80 text-white font-semibold">
            <div className="relative hidden sm:block">
              <div className="border-t w-9 border-dashed absolute border-rose-950 right-0 left-0 inset-y-20 -rotate-45">
                <div className="relative">
                  <div className="border-t w-16 border-dashed absolute border-rose-950 -left-16 right-0 -top-7 rotate-45 text-black text-xs">
                    Number of Hospitals
                  </div>
                </div>
              </div>
            </div>

            <div className="relative w-full">
              <div className="flex flex-col items-center absolute -inset-y-8 -inset-x-5">
                <span className="inline-block sm:hidden">Hospital</span>
                <span className="block sm:mt-5">
                  {loading ? 0 : new Intl.NumberFormat().format(+hospital)}
                </span>
              </div>
            </div>
          </div>
          <div className="rounded-full w-44 h-44 border-2 border-white border-dashed absolute right-0 flex items-center justify-center bg-bloodRed opacity-80 text-white font-semibold">
            <div className="relative hidden sm:block">
              <div className="border-t w-16 border-dashed absolute border-rose-950 left-16 -top-28 -rotate-45">
                <div className="relative">
                  <div className="border-t w-20 border-dashed absolute top-6 left-12 border-rose-950 top rotate-45 text-black text-xs">
                    Average Spend
                  </div>
                </div>
              </div>
            </div>
            <div className="relative w-full">
              <div className="flex flex-col items-center absolute -inset-y-8 -inset-x-5">
                <span className="inline-block sm:hidden">Average spent</span>
                <span className="block">
                  {loading ? 0 : currencyFormatter(spent, "$")}
                </span>
              </div>
            </div>
          </div>
          <div className="rounded-full w-44 h-44 border-2 border-white border-dashed absolute inset-16 top-24 flex items-center justify-center bg-bloodRed opacity-80 text-white font-semibold">
            <div className="relative hidden sm:block">
              <div className="border-t w-14 border-dashed absolute border-rose-950 left-36 inset-y-16 rotate-45">
                <div className="relative">
                  <div className="border-t w-16 border-dashed absolute border-rose-950 -right-16 -rotate-45 -top-7 text-black text-xs">
                    Revenue
                  </div>
                </div>
              </div>
            </div>
            <div className="relative w-full">
              <div className="flex flex-col items-center absolute -inset-y-3 -inset-x-5">
                <span className="inline-block sm:hidden">Revenue</span>
                <span className="block sm:mt-8">
                  {loading ? 0 : currencyFormatter(revenue, "$")}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
